import React, {useState} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

function BigImage({OpenImage, setOpenImage, talkktodocs}) {
    function checkContentType(content) {
        if (Array.isArray(content)) {
            return 'Array';
        } else if (typeof content === 'object' && content !== null) {
            return 'Object';
        } else {
            return 'Neither Array nor Object';
        }
    }
    return(
        <div className={`full-image-wrapper ${talkktodocs ? "has-ttd-overlay" : ""} ${OpenImage.show ? "open-full-image" : ""}`}>
            {
                talkktodocs ?
                    <div className='full-image-header'>
                        <p></p>
                        <button className='close-full-img-btn' onClick={()=>setOpenImage({show:false})}>close</button>
                    </div>
                :
                    <></>
            }
            {
                checkContentType(OpenImage.src) === "Array" ?
                    <>
                        <div className={`tlk-full-map-wrapper ${talkktodocs ? "" : "tlk-full-map-wrapper-mobi"}`}>
                            <Swiper slidesPerView={1}
                                modules={[Navigation]}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}>
                                {
                                    OpenImage.src?.map((data, i) => {
                                        return (
                                            <SwiperSlide>
                                                <img src={data?.url} />
                                            </SwiperSlide>
                                        )
                                    })
                                }
                            </Swiper>
                        </div>
                        <div className="swiper-button-prev"><KeyboardArrowLeftIcon /></div>
                        <div className="swiper-button-next"><KeyboardArrowRightIcon /></div>
                    </>
                :
                <img src={OpenImage.src} />
            }
            {!talkktodocs && <i className="bot icon-close-2-1" onClick={()=>setOpenImage({show:false})}></i>}
        </div>
    )
}
export default BigImage;
